export const WorkspaceConfig_DiseaseProfile_VarList = {
    name: 'Disease Property Data',
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            {
                name: 'leftPanel', key: 'variables', visible: true, factor: 1, min: 200,
                data: {}
            },
        ]
    }
};
